<template>
  <div class="sp-index-filters-panel">
    <sp-progress v-if="store.loading" type="ellipsis" size="x-small"></sp-progress>
    <sp-alert v-if="store.error" type="error"
      >{{ t("load_failed") }}
      <sp-button variant="appearance-link" :data-testid="TestId.admin.indexFiltersRetry" @click="emit('retry')">{{
        t("retry")
      }}</sp-button></sp-alert
    >
    <sp-tab-group v-if="hasTabs" :aria-label="tabsLabel">
      <sp-tab
        v-for="tab in store.tabs"
        :key="tab.key"
        slot="nav"
        :data-testid="TestId.admin.indexFilterTab"
        :panel="tab.key"
        @update-active="handleTab($event, tab)"
        >{{ tab.label }}</sp-tab
      >
      <sp-tab-panel v-for="tab in store.tabs" :key="tab.key" :name="tab.key">
        <div class="sp-index-filters-panel__fields">
          <section v-for="section in tab.sections" :key="section.key" class="sp-index-filters-panel__section">
            <h3 v-if="section.label">{{ section.label }}</h3>
            <IndexFiltersField
              v-for="(filter, index) in section.filters"
              :key="index"
              :filter="filter"
              @change="handleChange"
            />
          </section>
          <IndexFiltersField
            v-for="(filter, index) in tab.filters"
            :key="index"
            :filter="filter"
            @change="handleChange"
          />
        </div>
      </sp-tab-panel>
    </sp-tab-group>
    <IndexFiltersFooter v-if="showsFooter" @change="handleChange" @choose="emit('choose')" />
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { computed } from "vue";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";
import { t } from "#ce/apps/SpAdmin/SpIndexFilters/i18n";
import IndexFiltersField from "./IndexFiltersField.ce.vue";
import IndexFiltersFooter from "./IndexFiltersFooter.ce.vue";

const store = useIndexFiltersStore();
const emit = defineEmits(["change", "choose", "retry"]);
const hasTabs = computed(() => store.tabs.length > 0);
const showsFooter = computed(() => hasTabs.value || !store.loading);
const tabsLabel = computed(() => t("filters"));

function handleTab({ detail }, tab) {
  if (detail[0]) {
    store.activeTab = tab.key;
  }
}

function handleChange() {
  emit("change");
}
</script>

<style lang="scss" scoped>
.sp-index-filters-panel {
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  box-sizing: border-box;
  width: var(--sp-comp-admin-index-filters-panel-width, 25rem);
  max-height: var(--sp-popup-available-height, 100vh);

  > sp-progress {
    grid-row: 1;
    margin: var(--sp-ref-scale-16);
  }

  > sp-alert {
    grid-row: 2;
    margin: var(--sp-ref-scale-16);
  }

  > sp-tab-group {
    --sp-comp-tab-group-gap: 0;
    --sp-comp-tab-button-padding: 0;
    --sp-comp-tab-button-min-width: var(--sp-ref-scale-112);
    --sp-comp-tab-group-nav-gap: 0;

    grid-row: 3;
    padding-top: var(--sp-ref-scale-24);
  }

  sp-tab:first-of-type {
    margin-inline-start: var(--sp-ref-scale-16);
  }

  > .sp-index-filters-footer {
    grid-row: 4;
  }

  sp-tab-panel {
    min-height: 0;
    overflow: auto;
  }

  &__fields,
  &__section {
    display: grid;
    gap: var(--sp-ref-scale-16);
  }

  &__fields {
    padding: var(--sp-ref-scale-16);
  }
}
</style>
